<template>
  <fragment>
    <h5 v-if="!isLoading" class="mb-0">
      Total:
      <span class="total-amount">
        {{ value }} {{ currencyCode }}
      </span>
    </h5>
  </fragment>
</template>

<script>

export default {
  name: 'TotalAmount',
  props: {
    isLoading: Boolean,
    value: Number,
    currencyCode: String
  }
}
</script>

<style scoped lang="scss">
.total-amount {
  font-weight: normal;
}
</style>
